export type IGetUrlSeperator = (url: string) => string;

export function getUrlSeperator(url: string): string {
  if (typeof url === 'undefined') {
    console.warn('ERROR: No URL passed to getUrlSeperator()!');
    return '';
  }
  return url.indexOf('?') === -1 ? '?' : '&';
}
